const getters = {
  layout:             state => state.core.layout,
  navPos:             state => state.core.layout.navPos,
  toolbar:            state => state.core.layout.toolbar,
  footer:             state => state.core.layout.footer,
  boxed:              state => state.core.layout.boxed,
  roundedCorners:     state => state.core.layout.roundedCorners,
  viewAnimation:      state => state.core.layout.viewAnimation,
  isLogged:           state => state.core.logged,
  splashScreenstate:  state => state.core.splashScreen,
  rightMenu:          state => state.core.rightMenu,
  
  response:           state => state.response,
  // Document
  document:           state => state.inputAndOutputAdjust.document,
  detail:             state => state.inputAndOutputAdjust.detail,
  // response:           state => state.inputAndOutputAdjust.response,
  editDocument:       state => state.inputAndOutputAdjust.editing,
  inventoryAuditId:   state => state.inputAndOutputAdjust.inventoryAuditId,
  pending:            state => state.inputAndOutputAdjust.pending,
  // Third
  third:              state => state.third.third,
  // Product
  product:            state => state.product.product,
  // AdminTable
  adminTableList:     state => state.adminTable.list,
  
 }
 export default getters